import Barcode from 'react-barcode'

// see all options here: https://github.com/lindell/JsBarcode/wiki/Options
interface Props {
  value: string
  width?: number
  format: string
  height?: number
  displayValue?: boolean
}

function BarCodeComponent(props: Props) {
  return (
    <Barcode
      value={props.value}
      width={props.width}
      format={props.format}
      height={props.height}
      displayValue={props.displayValue}
    />
  )
}

export default BarCodeComponent
